import { render, staticRenderFns } from "./DialogHeader.vue?vue&type=template&id=40cd838b&scoped=true&"
import script from "./DialogHeader.vue?vue&type=script&lang=js&"
export * from "./DialogHeader.vue?vue&type=script&lang=js&"
import style0 from "./DialogHeader.vue?vue&type=style&index=0&id=40cd838b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cd838b",
  null
  
)

export default component.exports